import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { User } from '@shared/types/user';
import { multiSelectUserRowStyles } from './multiSelectUserRowStyles';

export function MultiSelectUserRow({ user }: { user: User }) {
  return (
    <View row centerVertically paddingVertical={1}>
      <MBUserImage style={multiSelectUserRowStyles.userImage} user={user} />
      <View flex centerVertically>
        <Text size="body1" numberOfLines={1}>
          {user.fullName}
        </Text>
      </View>
    </View>
  );
}
